import { useState } from "react";
import { Icon } from "../../components/Icon";
import { formatDateTime } from "../../lib/orders";
import { useClientNotes, useAddClientNote } from "../../lib/useClients";

export function ClientNotesTab({ clientId }: { clientId: string }) {
  const { data, isLoading } = useClientNotes(clientId);
  const addNote = useAddClientNote(clientId);
  const [draft, setDraft] = useState("");
  const notes = data ?? [];

  const submit = () => {
    const t = draft.trim();
    if (!t) return;
    addNote.mutate(t, { onSuccess: () => setDraft("") });
  };

  return (
    <>
      <div className="cd-note-composer">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Заметка оператора — видна только команде Mark & Post"
          rows={3}
        />
        <div className="cd-note-foot">
          <span className="muted" style={{ fontSize: 11 }}>
            Видна только команде
          </span>
          <button
            className="btn-admin primary sm"
            onClick={submit}
            disabled={!draft.trim() || addNote.isPending}
          >
            <Icon name="check" size={12} /> Добавить
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="cd-empty">
          <p>Загрузка…</p>
        </div>
      ) : notes.length === 0 ? (
        <div className="cd-empty">
          <p>Заметок пока нет</p>
        </div>
      ) : (
        <div className="cd-notes">
          {notes.map((n) => (
            <div key={n.id} className="cd-note">
              <div className="cd-note-head">
                <span className="cd-note-author">{n.authorChatId}</span>
                <span className="cd-note-date">
                  {formatDateTime(n.createdAt)}
                </span>
              </div>
              <p className="cd-note-text">{n.text}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
